module.exports = __webpack_public_path__ + "south-africa.ac7afddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/countries/south-africa.png
// module id = 126
// module chunks = 0